import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'pr-button-switch',
    templateUrl: './pr-button-switch.component.html',
    styleUrls: ['./pr-button-switch.component.scss'],
    standalone: false
})
export class PrButtonSwitchComponent implements OnInit {
  @Input() values: any[];
  @Input() defaultValue;
  @Output() onValueChange: EventEmitter<boolean> = new EventEmitter();

  value: any;

  ngOnInit() {
    this.value = this.defaultValue ? this.defaultValue : this.values[0].value;

    let outputValue = this.values.find(item => item.value === this.value);
    this.onValueChange.emit(outputValue);
  }

  onClick() {
    this.value = !this.value;

    let outputValue = this.values.find(item => item.value === this.value);
    this.onValueChange.emit(outputValue);
  }
}
